const inputValidations = {
  methods: {
    digitsOnlyInput(e) {
      let key = e.keyCode || e.which
      // The numpad keys lie between 96 to 105; subtracting 48 reverts to basic digits
      if (key >= 96 && key <= 105) {
        key -= 48
      }
      // need to convert to UTF-16 so regex can pickup backspace/tab etc because the event keycodes produced by js are not recognized in regex
      key = String.fromCharCode(key)
      if (!/[\t\d\b]/g.test(key)) {
        e.preventDefault()
      }
    },
    decimalInput(e) {
      let key = e.keyCode || e.which

      // navigation and editing keys
      if ([8, 9, 37, 38, 39, 40].includes(key) || e.key === 'Delete') {
        return
      }

      // The numpad keys lie between 96 to 105; subtracting 48 reverts to basic digits
      if (key >= 96 && key <= 105) {
        key -= 48
      }

      // period on main keyboard (190) or numpad decimal (110); 46 is period on some layouts
      if (key === 190 || key === 110 || (key === 46 && e.key === '.')) {
        if (e.target.value.includes('.')) {
          e.preventDefault()
        }
        return
      }

      key = String.fromCharCode(key)
      if (!/[\d]/g.test(key)) {
        e.preventDefault()
      }
    },
    normalizeNumericInput(value, min = 1, max = 1000, currentValue = null) {
      // Allow the user to clear the field while typing
      if (value === '' || value === null || value === undefined) {
        return null
      }

      let numeric = Number(value)
      if (isNaN(numeric)) {
        // Ignore non-numeric intermediate states and keep current value
        return currentValue
      }

      if (numeric < min) {
        numeric = min
      }
      if (numeric > max) {
        numeric = max
      }

      return numeric
    }
  }
}

export default inputValidations
